import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as StoresActions from '../../actions/content'
import { Channels as ChannelsDOM } from '../../components/Screens/Content'

class Channels extends PureComponent {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        fetchChannels: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            search: '',
        }

        this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount() {
        const { fetchChannels } = this.props
        fetchChannels()
    }

    // On Change any input value
    onChangeInput({ target: { name, value } }) {
        this.setState({ [name]: value }, this.search)
    }

    render() {
        const { data } = this.props
        const { search } = this.state
        return (
            <ChannelsDOM
                data={data}
                onChangeSearch={this.onChangeInput}
                valueSearch={search}
                style={{ overflow: 'hidden' }} // This didn't work
            />
        )
    }
}

const mapStateToProps = ({ content: { channels: data } }) => ({
    data,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...StoresActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(Channels)
